// Module
var code = `<button class="clear" ng-click="bulkChangeButtonController.open()" ng-show="bulkChangeButtonController.evaluationTypeId"> <i class="fa fa-truck" aria-hidden="true"></i> <span translate="Page.EvaluationList.BulkChange">Bulk change</span> </button> `;
// Exports
module.exports = code;